import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import Modal from "react-bootstrap/Modal";
import omsApi from "../../services/omsapi";
import { BiCloudDownload } from "react-icons/bi";
import moment from "moment/moment";
import jsPDF from "jspdf";
import "jspdf-autotable";
import logo from "../../static/base64img/logo"

function GenerateInvoice(invoiceDetails) {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const pageWidth = doc.internal.pageSize.getWidth();
  const margin = 40;
  const logoBase64 = logo.logo;



  const imgWidth = 60, imgHeight = 60;
  const imgX = (pageWidth - imgWidth) / 2, imgY = 10;

  doc.addImage(logoBase64, 'PNG', imgX, imgY, imgWidth, imgHeight);

  const nextY = imgY + imgHeight + 10;
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  const invoiceText = `Invoice #: ${invoiceDetails.order_showid}`;
  const dateText = `Date: ${moment(invoiceDetails.order_posteddate).format("YYYY/MM/DD HH:mm:ss")}`;
  const dateTextWidth = doc.getTextWidth(dateText);
  doc.text(invoiceText, margin, nextY);
  doc.text(dateText, pageWidth - margin - dateTextWidth, nextY);

  const billedTo = [
    invoiceDetails.shipping_name,
    invoiceDetails.shipping_mobile,
    invoiceDetails.shipping_address,
    invoiceDetails.shipping_landmark,
    invoiceDetails.customer_email
  ].filter(Boolean).join('\n');

  const billedFrom = [
    process.env.REACT_APP_COMPANY_NAME || "Grace Super Market",
    invoiceDetails.branch_address,
    invoiceDetails.branch_area,
    invoiceDetails.branch_city,
    `Pincode: ${invoiceDetails.branch_pincode}`
  ].filter(Boolean).join('\n');

  const usableWidth = pageWidth - margin * 2;
  const equalWidth = usableWidth / 2;

  doc.autoTable({
    startY: 100,
    head: [['Billed To:', 'Billed From:']],
    body: [[billedTo, billedFrom]],
    styles: { fontSize: 10, cellPadding: 4, valign: 'top' },
    headStyles: { fontStyle: 'bold' },
    columnStyles: {
      0: { cellWidth: equalWidth, halign: 'left' },
      1: { cellWidth: equalWidth, halign: 'left' }
    },
    margin: { left: 40, right: 40 }
  });

  let y = doc.lastAutoTable.finalY + 10;

  // 👇 New columns as per your request
  const tableColumn = ["DESCRIPTION", "MRP", "QTY", "AMOUNT", "DISCOUNT", "TOTAL AMOUNT"];
  const tableRows = invoiceDetails.products.map(item => {
    const quantity = item.quantity;
    const mrp = item.mrp;
    const salePrice = item.sale_price;
    const prodisc = item.orderlist_prodisc || 0;

    const totalMrp = mrp * quantity;
    const discount = prodisc > 0 ? prodisc * quantity : (mrp - salePrice) * quantity;
    const finalAmount = totalMrp - discount;

    return [
      `${item.name} ${item.unit} ${item.unit_type.toLowerCase()}`,
      mrp.toFixed(2),
      quantity.toString(),
      totalMrp.toFixed(2),
      discount > 0 ? discount.toFixed(2) : "-",
      finalAmount.toFixed(2)
    ];
  });

  doc.autoTable({
    head: [tableColumn],
    body: tableRows,
    theme: 'striped',
    styles: { fontSize: 9, cellPadding: 4 },
    headStyles: { fillColor: [0, 123, 255], textColor: 255 },
    startY: y + 5,
    margin: { left: 40, right: 40 },
  });
  const totalMrp = invoiceDetails.products.reduce(
    (sum, item) => sum + item.mrp * item.quantity,
    0
  );

  const totalDiscount = invoiceDetails.products.reduce((sum, item) => {
    const specialDiscount = item.orderlist_prodisc || 0;
    const isSpecial = specialDiscount > 0;
    const discount = isSpecial
      ? specialDiscount * item.quantity
      : (item.mrp - item.sale_price) * item.quantity;
    return sum + discount;
  }, 0);

  const deliveryCharge = Number(invoiceDetails.order_dlvrycharge || 0);
  const smartCartFee = Number(invoiceDetails.order_smartcart_fee || 0);
  const itemsNetAmount = totalMrp - totalDiscount;
  const totalFinalAmount = itemsNetAmount + deliveryCharge;

  const finalY = doc.lastAutoTable.finalY || (y + 100);
  doc.setFont("helvetica", "bold");
  doc.text(`Sub TOTAL: INR ${totalMrp.toFixed(2)}`, 360, finalY + 20);
  doc.text(`Total Discount: INR ${totalDiscount.toFixed(2)}`, 360, finalY + 40);

  let nextLineY = finalY + 60;
  if (deliveryCharge > 0) {
    doc.text(`Delivery Charge: INR ${deliveryCharge.toFixed(2)}`, 360, nextLineY);
    nextLineY += 20;
  }

  doc.text(`Total Amount: INR ${totalFinalAmount.toFixed(2)}`, 360, nextLineY);

  doc.setFontSize(10);
  doc.text("Thank you for your purchase!", 40, doc.internal.pageSize.height - 40);

  const filename = `GSM_${invoiceDetails.order_showid}.pdf`;
  doc.save(filename);
}



const InvoiceModal = ({ invModal, invoiceId, change }) => {
  const [invoiceModal, setInvoiceModal] = useState(invModal);
  const [invoiceDetails, setInvoiceDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const handleInvoiceClose = () => {
    setInvoiceModal(false);
    change();
  };

  useEffect(() => {
    setIsLoading(true);
    const fetchOrderDetail = async () => {
      try {
        const data = await omsApi.getOrderById(invoiceId);
        if (data) {
          setInvoiceDetails(data.data[0]);
          setIsLoading(false);
        }
      } catch (e) {
        console.error("Failed to fetch branch:", e);
      }
    };
    fetchOrderDetail();
  }, []);
  const indCurrency = "₹";

  const totalMrp =
    invoiceDetails?.products?.reduce((sum, item) => sum + item.mrp * item.quantity, 0) || 0;

  const totalDiscount =
    invoiceDetails?.products?.reduce((sum, item) => {
      const specialDiscount = item.orderlist_prodisc || 0;
      const isSpecial = specialDiscount > 0;
      const discount = isSpecial
        ? specialDiscount * item.quantity
        : (item.mrp - item.sale_price) * item.quantity;
      return sum + discount;
    }, 0) || 0;

  const deliveryCharge = Number(invoiceDetails?.order_dlvrycharge || 0);
  const smartCartFee = Number(invoiceDetails?.order_smartcart_fee || 0);
  const itemsNetAmount = totalMrp - totalDiscount;
  const totalFinalAmount = itemsNetAmount + deliveryCharge + smartCartFee;

  const paymentType =
    invoiceDetails?.order_paytype ??
    invoiceDetails?.order_paymenttype ??
    invoiceDetails?.paymentType ??
    0;

  const isDelivered = Number(invoiceDetails?.order_status || 0) === 6;
  const paidRupees =
    Number(invoiceDetails?.payment_amount_paise || 0) > 0
      ? Number(invoiceDetails.payment_amount_paise) / 100
      : Number(invoiceDetails?.order_amntpaid || 0);

  const refundedRupees = Number(invoiceDetails?.refunded_amount_paise || 0) / 100;
  const balanceRupees = Math.max(paidRupees - refundedRupees, 0);

  // const isRazorpay = Number(paymentType) === 4;
  const isOnlinePayment = Number(paymentType) === 4;
  const isFullyRefunded = isOnlinePayment && balanceRupees <= 0;
  // console.log(invoiceDetails, "invoiceDetails.products");
  const canRefund = isOnlinePayment && !isDelivered && !isFullyRefunded;
  const accessData = JSON.parse(localStorage.getItem("accessData") || "{}");
  const roleId = Number(accessData?.roleId);

  const ALLOWED_REFUND_ROLE_IDS = [1, 2, 8, 10];
  const isRefundRoleAllowed = ALLOWED_REFUND_ROLE_IDS.includes(roleId);
  const canShowRefundButton = canRefund && isRefundRoleAllowed;

  return (
    <div>
      <Modal show={invoiceModal} onHide={handleInvoiceClose} size="lg" centered>
        {isLoading || !invoiceDetails ? (
          "Order detail is loading...."
        ) : (
          <>
            <div id="invoiceCapture">
              <div className="d-flex justify-content-between align-items-start bg-light w-100 p-4">
                {/* LEFT */}
                <div>
                  <h4 className="fw-bold my-2">{invoiceDetails.customer_name}</h4>
                  <h6 className="fw-bold text-secondary mb-1">
                    Invoice #: {invoiceDetails.order_showid || ""}
                  </h6>
                  <h6 className="fw-bold text-secondary mb-1">
                    {moment(invoiceDetails.order_posteddate).format("YYYY/MM/DD kk:mm:ss")}
                  </h6>
                </div>
                <div>
                  {canShowRefundButton && (
                    <Button
                      variant="outline-danger"
                      size="sm"
                      className="px-4 mb-2"
                      onClick={() =>
                        window.open(`/admin/payments/refunds/create?orderId=${invoiceId}`, "_blank")
                      }
                    >
                     Refund Online Payment
                    </Button>
                  )}
                  <Button
                    variant="outline-primary"
                    size="sm"
                    className="px-4 mb-2"
                    onClick={() => window.open(`/admin/orders/location/${invoiceId}`, "_blank")}
                  >
                    View Location
                  </Button>
                </div>
                {/* RIGHT */}
                <div className="text-end" style={{ minWidth: 220 }}>


                  {isOnlinePayment ? (
                    <div>
                      <div className="fw-bold">Amount Paid:</div>
                      <div className="fw-bold text-secondary" style={{ fontSize: 22 }}>
                        {indCurrency} {paidRupees.toFixed(2)}
                      </div>

                      <div className="mt-1" style={{ fontSize: 13 }}>
                        <div>
                          <span className="fw-bold">Refunded:</span>{" "}
                          <span className="text-secondary">{indCurrency} {refundedRupees.toFixed(2)}</span>
                        </div>
                        <div>
                          <span className="fw-bold">Balance:</span>{" "}
                          <span className="text-secondary">{indCurrency} {balanceRupees.toFixed(2)}</span>
                        </div>

                        {refundedRupees > 0 && (
                          <div className="mt-1">
                            <span className="badge bg-warning text-dark">
                              {isFullyRefunded ? "FULLY REFUNDED" : "PARTIALLY REFUNDED"}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div className="fw-bold">Amount&nbsp;Due:</div>
                      <div className="fw-bold text-secondary" style={{ fontSize: 22 }}>
                        {indCurrency} {totalFinalAmount.toFixed(2)}
                      </div>
                    </div>
                  )}

                </div>
              </div>


              <div className="p-4">
                <Row className="mb-4">
                  <Col md={6}>
                    <div className="fw-bold">Billed to:</div>
                    <div>{invoiceDetails.shipping_name || ""}</div>
                    <div>{invoiceDetails.shipping_mobile || ""}</div>
                    {invoiceDetails.door_flat_no && (
                      <div>{invoiceDetails.door_flat_no}</div>
                    )}
                    <div>{invoiceDetails.shipping_address || ""}</div>
                    <div>{invoiceDetails.shipping_landmark || ""}</div>
                    <div>{invoiceDetails.customer_email || ""}</div>
                  </Col>
                  <Col md={6}>
                    <div className="fw-bold">Billed From:</div>
                    <div>{process.env.REACT_APP_COMPANY_NAME || "Grace Super Market"}</div>
                    <div>{invoiceDetails.branch_address || ''}</div>
                    <div>{invoiceDetails.branch_area || ''}</div>
                    <div>{invoiceDetails.branch_city || ''}</div>
                    <div>pincode {invoiceDetails.branch_pincode || ''}</div>
                  </Col>
                </Row>
                <Table className="mb-0">
                  <thead>
                    <tr>
                      <th>DESCRIPTION</th>
                      <th className="text-end">MRP</th>
                      <th>QTY</th>
                      <th className="text-end">AMOUNT</th>
                      <th className="text-end">DISCOUNT</th>
                      <th className="text-end">TOTAL AMOUNT</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoiceDetails.products.map((item, i) => {
                      const quantity = item.quantity;
                      const mrpAmount = item.mrp * quantity;
                      const specialDiscount = item.orderlist_prodisc * quantity || 0;

                      const isSpecial = specialDiscount > 0;
                      const discount = isSpecial
                        ? specialDiscount
                        : (item.mrp - item.sale_price) * quantity;

                      const finalAmount = mrpAmount - discount;

                      return (
                        <tr key={i}>
                          <td>
                            {item.name}
                            <span className="text-secondary  text-xs">
                              &nbsp; {item.unit} {item.unit_type.toLowerCase()}
                            </span>
                          </td>
                          <td className="text-end" style={{ width: "100px" }}>
                            {indCurrency} {item.mrp.toFixed(2)}
                          </td>
                          <td style={{ width: "70px" }}>{quantity}</td>
                          <td className="text-end" style={{ width: "100px" }}>
                            {indCurrency} {mrpAmount.toFixed(2)}
                          </td>
                          <td className="text-end" style={{ width: "100px" }}>
                            {discount > 0 ? `${indCurrency} ${discount.toFixed(2)}` : "-"}
                          </td>
                          <td className="text-end" style={{ width: "100px" }}>
                            {indCurrency} {finalAmount.toFixed(2)}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
                <Table>
                  <tbody>
                    <tr>
                      <td colSpan={6}>&nbsp;</td>
                    </tr>

                    <tr className="text-end">
                      <td></td>
                      <td className="fw-bold" colSpan={4} style={{ width: "200px" }}>
                        SUB TOTAL
                      </td>
                      <td className="text-end" style={{ width: "100px" }}>
                        {indCurrency} {totalMrp.toFixed(2)}
                      </td>
                    </tr>

                    <tr className="text-end">
                      <td></td>
                      <td className="fw-bold" colSpan={4} style={{ width: "200px" }}>
                        TOTAL DISCOUNT
                      </td>
                      <td className="text-end" style={{ width: "100px" }}>
                        {indCurrency} {totalDiscount.toFixed(2)}
                      </td>
                    </tr>

                    {deliveryCharge > 0 && (
                      <tr className="text-end">
                        <td></td>
                        <td className="fw-bold" colSpan={4} style={{ width: "200px" }}>
                          DELIVERY CHARGE
                        </td>
                        <td className="text-end" style={{ width: "100px" }}>
                          {indCurrency} {deliveryCharge.toFixed(2)}
                        </td>
                      </tr>
                    )}

                    {smartCartFee > 0 && (
                      <tr className="text-end">
                        <td></td>
                        <td className="fw-bold" colSpan={4} style={{ width: "200px" }}>
                          SMART CART FEE
                        </td>
                        <td className="text-end" style={{ width: "100px" }}>
                          {indCurrency} {smartCartFee.toFixed(2)}
                        </td>
                      </tr>
                    )}

                    <tr className="text-end">
                      <td></td>
                      <td className="fw-bold" colSpan={4} style={{ width: "200px" }}>
                        TOTAL AMOUNT
                      </td>
                      <td className="text-end" style={{ width: "100px" }}>
                        {indCurrency} {totalFinalAmount.toFixed(2)}
                      </td>
                    </tr>
                  </tbody>
                </Table>

                {invoiceDetails.notes && (
                  <div className="bg-light py-3 px-4 rounded">
                    {invoiceDetails.notes}
                  </div>
                )}
              </div>
            </div>
            <div className="">
              <Row>

                <Col>

                  {(invoiceDetails.order_shipnotes ||
                    invoiceDetails.order_shipno ||
                    invoiceDetails.order_feedbackdate ||
                    invoiceDetails.feedback_comment ||
                    invoiceDetails.feedback_status ||
                    invoiceDetails.order_reason ||
                    invoiceDetails.order_cusreason ||
                    invoiceDetails.order_cus_instruction) && (
                      <div className="bg-white border rounded mt-4 p-3">
                        <h6 className="fw-bold mb-3">Additional Order Details</h6>
                        <ul className="ps-3 mb-0">
                          {invoiceDetails.order_shipnotes && (
                            <li>
                              <strong>Shipping Notes:</strong> {invoiceDetails.order_shipnotes}
                            </li>
                          )}
                          {invoiceDetails.order_shipno && (
                            <li>
                              <strong>Shipping No:</strong> {invoiceDetails.order_shipno}
                            </li>
                          )}
                          {invoiceDetails.order_feedbackdate && (
                            <li>
                              <strong>Feedback Date:</strong>{" "}
                              {moment(invoiceDetails.order_feedbackdate).format("YYYY-MM-DD HH:mm")}
                            </li>
                          )}

                          {invoiceDetails.feedback_comment && (
                            <li>
                              <strong>Feedback Comment:</strong> {invoiceDetails.feedback_comment}
                            </li>
                          )}
                          {invoiceDetails.order_reason && (
                            <li>
                              <strong>Order Reason:</strong> {invoiceDetails.order_reason}
                            </li>
                          )}
                          {invoiceDetails.order_cusreason && (
                            <li>
                              <strong>Customer Reason:</strong> {invoiceDetails.order_cusreason}
                            </li>
                          )}
                          {invoiceDetails.order_cus_instruction &&
                            invoiceDetails.order_cus_instruction.trim() !== "" && (
                              <li>
                                <strong>Customer Instruction:</strong>
                                <pre style={{ whiteSpace: 'pre-wrap', margin: 0 }}>
                                  {invoiceDetails.order_cus_instruction}
                                </pre>
                              </li>
                            )}
                        </ul>
                      </div>
                    )}
                </Col>
              </Row>
            </div>
            <div className="pb-4 px-4">

              <Row>
                <Col md={6}>
                  <Button
                    variant="danger"
                    className="d-block w-100"
                    onClick={handleInvoiceClose}
                  >
                    Close
                  </Button>
                </Col>
                <Col md={6}>
                  <Button
                    variant="outline-primary"
                    className="d-block w-100 mt-3 mt-md-0"
                    onClick={() => GenerateInvoice(invoiceDetails)}
                  >
                    <BiCloudDownload
                      style={{
                        width: "16px",
                        height: "16px",
                        marginTop: "-3px",
                      }}
                      className="me-2"
                    />
                    Download Copy
                  </Button>
                </Col>
              </Row>
            </div>
          </>
        )}
      </Modal>
      <hr className="mt-4 mb-3" />
    </div>
  );
};

export default InvoiceModal;